/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { useNavigate, Link } from 'react-router-dom';
import './DocumentListTable.scss';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import useDate from 'src/Admin/utils/useDate';

const DocumentListTable = ({
  columns,
  data,
  pageSizeCount,
  labelProp = 'Documents List',
  preserveData,
  userSpecDoc = false,
  docType,
  selectedDocTypeData,
  physicianType,
  docTypeMeta,
  selectedLocationData,
  documentListNoDataError,
  searchText = '',
  initialSortBy = {},
}) => {
  const { formatDate } = useDate();
  console.log('preserveData--@', preserveData);
  console.log('data--@', data);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeCount,
        sortBy: [initialSortBy],
      },
    },
    useSortBy,
    usePagination,
  );

  const onClick = (ele) => {
    if (ele) {
      console.log(ele, 'PageRedirect');
      navigate('/admin/view-documents', {
        state: {
          ...preserveData,
          ...ele?.original,
          userSpecDoc,
          docType,
          selectedDocTypeData,
          physicianType,
          docTypeMeta,
          selectedLocationData,
        },
      });
    }
  };

  const linkFormatter = (value) => {
    return (
      <Link to={'/admin/view-documents'} state={preserveData}>
        <span className="link-colors">{value}</span>
      </Link>
    );
  };

  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);
  //Render the UI for your table
  return (
    <>
      <div className="document-list-table-admin">
        <table
          className="table padding-mobile-0"
          {...getTableProps()}
          aria-rowcount={data?.length}
          onBlur={() => setIsLoading(true)}
        >
          <caption className="sr-only">{labelProp}</caption>
          {data?.length > 0 && (
            <thead>
              {headerGroups.map((headerGroup, index) => (
                <tr
                  key={index}
                  {...headerGroup.getHeaderGroupProps()}
                  role="row"
                  className="doc-row"
                >
                  {headerGroup.headers.map((column) => (
                    <th
                      key={index}
                      {...column.getHeaderProps(
                        column.getSortByToggleProps({ title: undefined }),
                      )}
                      scope="col"
                      role="columnheader"
                      onKeyPress={(event) => {
                        if (
                          column.sortable !== false &&
                          event.key === 'Enter'
                        ) {
                          column.toggleSortBy();
                        }
                      }}
                      className={
                        column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                      }
                    >
                      <b className="document-title">
                        {column.render('Header')}
                      </b>
                      <span
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'arrowDown'
                              : 'arrowUp'
                            : 'arrowNormal'
                        }
                        tabIndex={0}
                        aria-label={
                          column.isSorted
                            ? column.isSortedDesc
                              ? ` ${column.Header} sorted descending`
                              : ` ${column.Header} sorted ascending`
                            : ` ${column.Header} sorted none`
                        }
                        aria-live="polite"
                        aria-atomic={isLoading}
                        aria-sort={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'descending'
                              : 'ascending'
                            : 'none'
                        }
                      ></span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          )}
          <tbody {...getTableBodyProps()} role="rowgroup">
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr key={index} {...row.getRowProps()}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        {...cell.getCellProps()}
                        role="cell"
                        onClick={() => (index === 0 ? onClick(row) : null)}
                      >
                        {cell?.value?.length > 24 ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 200, hide: 450 }}
                            overlay={
                              <Popover>
                                <Popover.Content>
                                  <div className="tooltip-header">
                                    {cell.render('Cell')}
                                  </div>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <p className="document-data-admin">
                              {index === 0
                                ? linkFormatter(cell.render('Cell'))
                                : cell.render('Cell')}
                            </p>
                          </OverlayTrigger>
                        ) : (
                          <p className="document-data">
                            {index === 0
                              ? linkFormatter(cell.render('Cell'))
                              : index === 1
                              ? formatDate(cell?.row?.original?.SentDate)
                              : cell.render('Cell')}
                          </p>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {((data?.length == 0 && documentListNoDataError) ||
          (data?.length === 0 && searchText?.length > 0)) && (
          <div className="document-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading="No Documents found!"
              ErrorMessage="We could not find any documents for the selected filter(s).
            Use another filter(s) and try again."
            />
          </div>
        )}
      </div>
    </>
  );
};

export default DocumentListTable;
